import useErrorHandler from '~/composable/useErrorHandler';

export default function ({ $axios, _redirect }) {
  $axios.onRequest(_config => {
    // console.log('Making request to ' + config.url)
  })
  $axios.onError(error => {
    const { setRequestError } = useErrorHandler()

    const code = parseInt(error?.response?.status)
    console.log('Error intercepted with http status: ', code)
    if (error?.response?.data) {
      setRequestError({
        url: error.config.url,
        data: error.response.data
      })
    }
  })
}
